// @ts-check

// import locale from '@/configs/locale.js'

// Import locales pack for veutify (add / remove desired locales)

// @ts-ignore
import zhHant from 'vuetify/src/locale/zh-Hant.ts'
// @ts-ignore
import ja from 'vuetify/src/locale/ja.ts'
// @ts-ignore
import en from 'vuetify/src/locale/en.ts'

export default {
  /**
   * Defines icon settings in vuetify
   * Currently installed fonts: [mdi, FontAwesome6]
   * @see https://vuetifyjs.com/en/features/icon-fonts/
   */
  icons: {
    iconfont: 'mdi'
  },
  /**
   * Defines i18n settings in vuetify
   * @see https://vuetifyjs.com/en/features/internationalization/
   */
  lang: {
    locales: {ja, zhHant,  en },
    current: 'ja'
  },
  /**
   * Defines theme related settings in vuetify
   * @see https://vuetifyjs.com/en/features/theme/
   */
  theme: {
    options: { customProperties: true },
    themes: { light: { primary: '#027440' } }
  }
}
